__turbopack_context__.v({
  "main": "page-module__MVT91W__main",
  "titleWrapper": "page-module__MVT91W__titleWrapper",
});
